import React, { Component } from "react";
import { Button } from "reactstrap";
import { UncontrolledTooltip } from "reactstrap";
import ModalArea from '../ModalArea';
import { async } from 'q';
import { fetchData } from "../common/networkRequests";
import { generateOtherValues,setCookie } from "../oro-module/commonFunctions";
import { getObjectsValue } from "../../pages/commonFunctions";
import { FaExternalLinkAlt } from "react-icons/fa";



class LinkCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      modalProps: false
    };
  }

  generateID = () => {
    return this.state.ttid;
  };

  handleClick = async () => {
    const { onclick, requiredValue, convertedTo, name, } = this.props.component;
    let {parentState}=this.props;
    const { currentPage, LocalVars, pageData, modalname, remoteip } = parentState;
    let { hotdata } = LocalVars;
    let { parentName, st } = this.state;
    let { token } = this.props.parentProps.parentState;

    let CBSurl = `${remoteip}/sentry`;
    let method = 'post';
    let actions = [];
    if (typeof (onclick.action) == 'string') {
      actions = [{ act: onclick.action }];
    } else {
      actions = onclick.action;
    }

    for (var i = 0; i < actions.length; i++) {
      let action = actions[i];
      // if download a file.
      if (action.act == "handleAppendmodal") {
        this.setState({ modalProps: true });
        let om = parentState.openmodals;
        om.push(name);
      } else if (action.act == 'handleOpenNewtab') {
        let unique_id;
        if(this.props.component.unique_id){
          unique_id=getObjectsValue(parentState,this.props.component.unique_id);
        }else{
          unique_id=pageData.unique_id;
        }
        let { pagename, form, payload } = this.props.component;
        let def = { set: {} };
        if (payload) {
          for (var key in payload) {
            if (typeof payload[key] == 'string') {
              def['set'][key] = getObjectsValue(parentState, payload[key]);
            } else {
              def['set'][key] = payload[key]['formula'];
            }
          }
        }
        if (form) {
          def['unique_id'] = unique_id;
        }

        let identi = Math.round(Math.random() * 10000000000);
        setCookie(identi, JSON.stringify(def));

        let url;
        if (unique_id) {
          url = "/" + pagename + "/" + identi;
        }
        window.open(url, '_blank');

      } else if (action.act == 'checkAAdharUID') {
        let { dataType, sendData } = action.sendToServer;
        let saveThis = { dataType, dependantOnValues: sendData && generateOtherValues(sendData, pageData) };
        let { results, exceptions, vendorErrors, error } = await fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
        if (results) {
          if (Object.keys(results).length != 0) {
            this.props.liftState({ name: 'customer_number' }, results[0]);
            this.props.liftState({ name: 'unlink_message' }, "AADHAAR Unlinked");
          } else {
            // show warning message, AADHAAR not linked.
            this.props.liftState({ name: 'unlink_message' }, "AADHAAR not linked");
          }
          this.props.liftState({ name: 'unlinked' }, 1);
        } else {
          this.props.liftState({ name: 'unlinked' }, 0);
        }
      } else if (action.act == 'unlockAccountNumber') {
        let { dataType, sendData } = action.sendToServer;
        let saveThis = { dataType, dependantOnValues: sendData && generateOtherValues(sendData, pageData), currentPage };
        // The following request should be non blocking.
        let { results, exceptions, vendorErrors, error } = fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
      } else if (action.act == 'clearHTMLTableForm') {

        // check if required fields are filled. If yes then proceed.
        let { tableNameField, requiredField, removeExcept, required } = onclick;
        let fieldData;
        if (modalname) {
          fieldData = pageData[modalname];
        } else {
          fieldData = pageData;
        }
        if (!fieldData) { fieldData = {}; }

        // Clear the current form.
        requiredField.map(fld => {
          delete fieldData[fld];
        });
        // Check if other fields are to be removed forcefully.
        if (removeExcept) {
          for (var key in fieldData) {
            // console.log(key)
            if (removeExcept.indexOf(key) == -1 && key != tableNameField) {
              delete fieldData[key];
            }
          }
        }
        // console.log({fieldData})
        this.props.liftGlobalState({ name: 'errorMessages' }, {});
      }
      else if (action.act == 'appendToHTMLTable') {

        // check if required fields are filled. If yes then proceed.
        let { tableNameField, requiredField, removeExcept, required } = onclick;
        let fieldData;
        if (modalname) {
          fieldData = pageData[modalname];
        } else {
          fieldData = pageData;
        }
        if (!fieldData) { fieldData = {}; }

        let tableVals = fieldData[tableNameField] ? fieldData[tableNameField] : [];

        let temp = {}; let shouldAdd = true; let requiredCols = {};
        let tableErrors = {};

        // Check if all the required fields are filled.
        requiredField && requiredField.map(head => {
          if (!fieldData[head] && required && required.indexOf(head) != -1) {
            shouldAdd = false;
            tableErrors[head] = "Required";
          }
        })

        // create table row.
        if (shouldAdd) {
          requiredField.map(head => {
            temp[head] = fieldData[head];
          });
          tableVals.push(temp);
          this.props.liftState({ name: tableNameField }, tableVals);
          // Clear the current form.
          requiredField.map(fld => {
            delete fieldData[fld];
          });

          // Check if other fields are to be removed forcefully.
          if (removeExcept) {
            for (var key in fieldData) {
              // console.log(key)
              if (removeExcept.indexOf(key) == -1 && key != tableNameField) {
                delete fieldData[key];
              }
            }
          }
        } else {
          let err = this.props.errorMessages;
          if (!err) { err = {}; }
          if (modalname) {
            err[modalname] = tableErrors;
          } else {
            err = tableErrors;
          }
          this.props.liftGlobalState({ name: 'errorMessages' }, err);
        }
        console.log("appended")
      }
    }

  };

  liftControlsState = (stateName, stateValue) => {
    this.setState({ [stateName]: stateValue });
  }

  render() {
    let {
      name,
      Bcolor,
      style,
      size,
      label,
      placeHolder,
      isRequired,
      description,
      Blocktype
    } = this.props.component;
    let { conditionalRender } = this.props;

    const tooltipID = this.generateID();
    let classval = "";
    let classval1 = "";
    !style && (style = {})

    !size && (size = "sm")
    Blocktype === "block" && (classval = "btn-block")
    Bcolor ? (classval1 = Bcolor) : (classval1 = "info");

    return (
      <div
        id={tooltipID}
        className={`form-group ${this.props.component.widths.parent}`}
      >
        {conditionalRender && conditionalRender != 'blank' &&
          <div
            size={size}
            className={`${classval} col-sm-12 underline hand linkColor`}
            onClick={this.handleClick}
            style={style}
            id={name}
          >
            {label}&nbsp;
            <FaExternalLinkAlt style={{height:10}}/>
          </div>
        }
      </div>
    );
  }
}

export default LinkCustom;
